module.exports = __webpack_public_path__ + "img/feature_buy_zh.a83e8c27.png";